export enum ValidationTypes {
    Email = 'email',
    Max = 'max',
    MaxLength = 'maxlength',
    Min = 'min',
    MinLength = 'minlength',
    Required = 'required',
    RequiredTrue = 'requiredtrue',
    Pattern = 'pattern',
    Decimal = 'decimal',
    Time = 'time',
    LessThanField = 'lessThanField',
    EqualOrLessThanField = 'equalOrLessThanField',
    GreaterThanField = 'greaterThanField',
    EqualOrGreaterThanField = 'equalOrGreaterThanField',
    Date = 'date'
}